import { Link } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { useSubscription } from 'services/hooks';
import {
  StyledHelperTextContainer,
  StyledHelperTextTypography,
  StyledSpan,
} from './styled';

const GET_IN_TOUCH_LINK = 'mailto:help@loudly.com';
const HelperText = () => {
  const { t } = useTranslation();
  const { isFreeAccount } = useSubscription();
  const getInTouch = t('account:youtubeChannel:whitelistContainer:getInTouch');

  return (
    <StyledHelperTextContainer>
      <StyledHelperTextTypography>
        <Trans i18nKey="account:youtubeChannel:whitelistContainer:helperText">
          {isFreeAccount ? (
            <StyledSpan>{{ getInTouch }}</StyledSpan>
          ) : (
            <Link href={GET_IN_TOUCH_LINK}>{{ getInTouch }}</Link>
          )}
        </Trans>
      </StyledHelperTextTypography>
    </StyledHelperTextContainer>
  );
};

export default HelperText;
